<hlm-dialog-surface size="sm">
  <hlm-dialog-header>
    <hlm-dialog-icon-badge tone="primary">
      <hlm-icon name="lucideBuilding2" size="1.1rem" />
    </hlm-dialog-icon-badge>
    <div hlmDialogHeading>
      @if (data.existing) {
        <h2 hlmDialogTitle>Edit sub-brand — {{ data.existing.name }}</h2>
        <p hlmDialogDescription>
          Update the details for this sub-brand.
        </p>
      } @else {
        <h2 hlmDialogTitle>Add sub-brand</h2>
        <p hlmDialogDescription>
          Create a new sub-brand under a parent brand.
        </p>
      }
    </div>
    <button hlmDialogClose tabindex="-1" (click)="cancel()">
      <hlm-icon name="lucideX" size="1rem" />
    </button>
  </hlm-dialog-header>

  <section hlmDialogBody>
    <form id="subBrandForm" [formGroup]="form" class="flex flex-col gap-5" (ngSubmit)="submit()">

      <!-- Live logo preview — parent brand's asset folder + the sub-brand name.
           cmt-brand-logo drops its <img> on 404, so this stays empty (no frame)
           for sub-brands without a dedicated logo asset. -->
      @if (parentDomain() && previewName()) {
        <div class="flex items-center justify-center py-2">
          <cmt-brand-logo
            [domain]="parentDomain()"
            [subBrand]="previewName()"
            variant="hero"
            heightOverride="4.5rem"
          />
        </div>
      }

      <!-- Name field -->
      <label class="flex flex-col gap-1.5">
        <span class="cmt-eyebrow">Name *</span>
        <input
          hlmInput
          type="text"
          formControlName="name"
          placeholder="e.g. Medisek"
          autocomplete="off"
        />
        @if (form.controls.name.touched && form.controls.name.errors?.['required']) {
          <p class="text-sm text-destructive">Name is required.</p>
        }
      </label>

      <!-- Parent brand picker -->
      <label class="flex flex-col gap-1.5">
        <span class="cmt-eyebrow">Parent brand *</span>
        <select hlmNativeSelect formControlName="parentBrand">
          <option [ngValue]="null" disabled>— select parent brand —</option>
          @for (brand of data.brands; track brand.id) {
            <option [ngValue]="brand.id">{{ brand.name }}</option>
          }
        </select>
        @if (form.controls.parentBrand.touched && form.controls.parentBrand.invalid) {
          <p class="text-sm text-destructive">A parent brand is required.</p>
        }
      </label>

      <!-- Description field -->
      <label class="flex flex-col gap-1.5">
        <span class="cmt-eyebrow">Description *</span>
        <input
          hlmInput
          type="text"
          formControlName="description"
          placeholder="Short description of this sub-brand"
          autocomplete="off"
        />
        @if (form.controls.description.touched && form.controls.description.errors?.['required']) {
          <p class="text-sm text-destructive">Description is required.</p>
        }
      </label>

      <!-- Default price list (optional) -->
      <label class="flex flex-col gap-1.5">
        <span class="cmt-eyebrow">Price list (optional)</span>
        <select hlmNativeSelect formControlName="defaultPriceListId">
          <option [ngValue]="null">— none —</option>
          @for (priceList of data.priceLists; track priceList.id) {
            <option [ngValue]="priceList.id">{{ priceList.name }}</option>
          }
        </select>
      </label>

      <!-- Usage fee limit (optional) -->
      <label class="flex flex-col gap-1.5">
        <span class="cmt-eyebrow">Usage fee limit (optional)</span>
        <input
          hlmInput
          type="number"
          step="any"
          formControlName="defaultNgLimit"
          placeholder="e.g. 5"
        />
      </label>

      <!-- Inline error -->
      @if (errorMessage()) {
        <hlm-alert tone="error">
          <hlm-icon name="lucideCircleAlert" size="1rem" />
          {{ errorMessage() }}
        </hlm-alert>
      }

    </form>
  </section>

  <footer hlmDialogFooter>
    @if (data.existing && canWrite()) {
      <button
        hlmBtn
        variant="destructive"
        type="button"
        class="mr-auto"
        [disabled]="deleting() || saving()"
        (click)="confirmDelete()"
      >
        @if (deleting()) {
          <hlm-spinner size="16" />
          Deleting…
        } @else {
          <hlm-icon name="lucideTrash2" size="0.9rem" />
          Delete
        }
      </button>
    }
    <button hlmBtn variant="outline" type="button" (click)="cancel()">Cancel</button>
    <button
      hlmBtn
      variant="default"
      type="submit"
      form="subBrandForm"
      [disabled]="saving() || deleting() || !canWrite()"
    >
      @if (saving()) {
        <hlm-spinner size="16" />
        Saving…
      } @else {
        <hlm-icon name="lucideCheck" size="0.9rem" />
        @if (data.existing) { Save } @else { Add sub-brand }
      }
    </button>
  </footer>
</hlm-dialog-surface>
